import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';

export const RootStyled = styled(Box)({
  border: '1px solid #B0B0B0',
  padding: 16,
  borderRadius: '8px',
  margin: '54px 0 20px 0',
});
